import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue';

import RangeInput from '@/ui-components/RangeInput.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';
import ResetButton from '@/components/buttons/ResetButton.vue';

import { FilterCollection } from '@/stores/filter.store';
import { useFilterStore } from '@/helpers/composables/useStores';

import { CollectionType } from '@/enums/collection-type';
import { isAnyFilterActive } from '@/helpers/filter-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterReleaseYear',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};

const min = 1900;
const max = new Date().getFullYear();



const releaseYear = ref();
const { setRange } = useFilterStore();

const presetFiltersActive = computed(() => ({
	WEBAPP_RELEASEYEAR_THIS:
		props.currentFilters.release_year_from === max &&
		!isAnyFilterActive(['release_year_until'], props.currentFilters),
	WEBAPP_RELEASEYEAR_LAST:
		props.currentFilters.release_year_from === max - 1 && props.currentFilters.release_year_until === max - 1,
}));

const rangeValue = computed<RangeDualKnobValue>(() => ({
	lower: props.currentFilters.release_year_from || min,
	upper: props.currentFilters.release_year_until || max,
}));

function setPreset(value: RangeDualKnobValue & { key: string }) {
	const { release_year_from, release_year_until } = props.currentFilters;

	const lower = release_year_from === value.lower ? null : value.lower;
	const upper = release_year_until === value.upper ? null : value.upper;

	update([lower, upper], value.key);
}

function update(value: any[], key: string) {
	const selectedState = isDateFilterActive(key) ? 0 : 1;

	setRange({
		rangeName: 'release_year',
		trackingKey: key,
		upper: value[1] !== max ? value[1] : null,
		lower: value[0] !== min ? value[0] : null,
		selectedState,
	});
}

function isDateFilterActive(key: string): boolean {
	return (
		['WEBAPP_RELEASEYEAR_LAST', 'WEBAPP_RELEASEYEAR_THIS'].includes(key) &&
		(presetFiltersActive.value.WEBAPP_RELEASEYEAR_LAST || presetFiltersActive.value.WEBAPP_RELEASEYEAR_THIS)
	);
}

function setSlideValue(value: RangeDualKnobValue) {
	releaseYear.value = [value.lower, value.upper];
}

watch(rangeValue, (newValue: RangeDualKnobValue, oldValue: RangeDualKnobValue) => {
	setSlideValue(newValue);
});

watch(releaseYear, () => {
	if (releaseYear.value[1] === rangeValue.value.upper && releaseYear.value[0] === rangeValue.value.lower) {
		return;
	}

	update(releaseYear.value, 'knob');
});

onMounted(() => {
	setSlideValue(rangeValue.value);
});

return { __sfc: true,min, max, props, releaseYear, setRange, presetFiltersActive, rangeValue, setPreset, update, isDateFilterActive, setSlideValue, RangeInput, ToggleButton, ResetButton }
}

})